document.addEventListener('DOMContentLoaded', function () {
  // ITEMS セクションの公開日時スイッチ
  // data-reveal-at は日本時間（+09:00）で指定する。閲覧者のタイムゾーンに関係なく同じ瞬間に切り替わる。
  const now = new Date();
  document.querySelectorAll('.hlt-osaka-20260926 [data-reveal-at]').forEach(function (block) {
    const comingSoon = block.querySelector('[data-reveal="before"]');
    const published = block.querySelector('[data-reveal="after"]');
    if (now >= new Date(block.dataset.revealAt)) {
      if (comingSoon) comingSoon.remove();
      if (published) published.style.display = 'block';
    } else {
      if (published) published.remove();
    }
  });

  // カルーセル（公開後に DOM に残っているものだけ初期化する）
  document.querySelectorAll('.hlt-osaka-20260926__carousel').forEach(function (carousel) {
    new Swiper(carousel.querySelector('.swiper'), {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      speed: 1800,
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },
    });
  });
});
